import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { Entity } from '../types/entity';
import { entityHexColourCache } from './cache';
import { AxiosError } from 'axios';

type GetEntityResponse = {
    entity: Entity;
};

export function genColour(id: string): string {
    if (entityHexColourCache[id]) {
        return entityHexColourCache[id];
    }
    const colours = ['gray', 'red', 'yellow', 'green', 'blue', 'violet', 'indigo', 'pink', 'orange'];
    const profileHexColour = colours[Math.floor(Math.random() * colours.length)];
    entityHexColourCache[id] = profileHexColour;

    return profileHexColour;
}

export function generateAvatarColour(data: GetEntityResponse): GetEntityResponse {
    return { ...data, entity: { ...data.entity, avatarHexColour: genColour(data.entity.id) } };
}

async function getEntity(id?: string): Promise<GetEntityResponse> {
    const { data } = await api.get(`/entities/${id}`);
    return data;
}

export function useEntity(id?: string): UseQueryResult<GetEntityResponse, AxiosError> {
    return useQuery(['entities', id], () => getEntity(id), {
        keepPreviousData: true,
        enabled: Boolean(id),
        select: generateAvatarColour,
    });
}
